import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@ondit/ui";
import { Async, PageHead } from "@/components/ui";
import { useI18n, useT } from "@/i18n";
import { api } from "@/lib/api";
import { useAsync } from "@/lib/hooks";

export function CataloguePage() {
	const t = useT();
	const { locale } = useI18n();
	const state = useAsync(() => api.industries(), []);

	return (
		<>
			<PageHead title={t("catalogue.title")} lede={t("catalogue.lede")} />
			<Async state={state}>
				{({ industries, categories }) => (
					<div className="stack">
						{industries.map((industry) => {
							const own = categories.filter((c) => c.industry_id === industry.id);
							// ondit's groups hang under Shopify's software nodes, which this
							// page does not list, so a root is whatever has no parent here.
							const listed = new Set(own.map((c) => c.id));
							const roots = own.filter((c) => !c.parent_id || !listed.has(c.parent_id));
							return (
								<div className="card" key={industry.id}>
									<h2>
										{locale === "zh" ? industry.name_zh : industry.name_en}{" "}
										<span className="mono faint">{industry.slug}</span>
									</h2>
									<p className="hint">
										{t("catalogue.locales")}: {industry.locales.join(", ")} · {t("catalogue.entities")}:{" "}
										{industry.entities}
									</p>
									<Table style={{ marginTop: "var(--s-6)" }}>
										<TableHeader>
											<TableRow>
												<TableHead>{t("catalogue.category")}</TableHead>
												<TableHead>{t("catalogue.slug")}</TableHead>
												<TableHead className="num">{t("catalogue.entities")}</TableHead>
											</TableRow>
										</TableHeader>
										<TableBody>
											{roots.flatMap((root) => [
												<TableRow key={root.id}>
													<TableCell>
														<strong>{locale === "zh" ? root.name_zh : root.name_en}</strong>
													</TableCell>
													<TableCell className="mono">{root.slug}</TableCell>
													<TableCell className="num">{root.entities}</TableCell>
												</TableRow>,
												...own
													.filter((c) => c.parent_id === root.id)
													.map((child) => (
														<TableRow key={child.id}>
															<TableCell style={{ paddingLeft: "var(--s-11)" }}>
																{locale === "zh" ? child.name_zh : child.name_en}
															</TableCell>
															<TableCell className="mono">{child.slug}</TableCell>
															<TableCell className="num">{child.entities}</TableCell>
														</TableRow>
													)),
											])}
										</TableBody>
									</Table>
								</div>
							);
						})}
					</div>
				)}
			</Async>
		</>
	);
}
